import { z } from "zod";

export const whatsappNameSchema = z.object({
  verifiedName: z.string().optional().nullish(),
  displayPhoneNumber: z.string().optional().nullish(),
  qualityRating: z.string().optional().nullish(),
  newDisplayName: z.string().optional().nullish(),
  messagingLimitTier: z.string().optional().nullish(),
});

export type TWhatsappNameForm = z.infer<typeof whatsappNameSchema>;
